import React from 'react'
import { Card } from 'reactstrap'
import Approval from '../../assets/Approval'
import { useSearchParams } from 'react-router-dom'

const ManufacturerApproval = () => {
  const [searchParams] = useSearchParams()

  const pharmacyName = searchParams.get('pharmacyName')
  const manufacturer = searchParams.get('manufacturer')
  return (
    <div className='min-vh-100 d-flex justify-content-center align-items-center'>
      <Card className='w-100 m-3' style={{ maxWidth: '1300px' }}>
        <main className='text-center p-4'>
          <Approval />
          <section>
            <h1 className='h4 mb-3 mt-4'>Application Approved</h1>
            <p className='lead'>
              {pharmacyName} has been successfully approved to use OD with{' '}
              {manufacturer}.
            </p>
          </section>
        </main>
      </Card>
    </div>
  )
}

export default ManufacturerApproval
